import { Fragment, lazy } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import axios from "axios";
import OperatorContent from "./admin/pages/user";
import Login from "./admin/pages/auth/Login";
import { useAuthBloc } from "./core/provider/Provider";
import { BlocBuilder } from "react-stream-bloc";
import { AuthState } from "./core/bloc/auth/auth_state";
import LineContent from "./admin/pages/line";
import VerifyAccount from "./admin/pages/auth/VerifyAccount";
import TablePage from "./admin/pages/table";
import ExportPage from "./admin/pages/Export";
// Admin
const Admin = lazy(() => import("./admin/pages/Admin"));
const Dashboard = lazy(() => import("./admin/pages/Dashboard"));
const Faq = lazy(() => import("./admin/pages/Faq"));
const HelpCenter = lazy(() => import("./admin/pages/HelpCenter"));
const Profile = lazy(() => import("./admin/pages/Profile"));
const ProfileInformation = lazy(
  () => import("./admin/pages/ProfileInformation")
);
const ProfilePassword = lazy(() => import("./admin/pages/ProfilePassword"));
const UserLineContent = lazy(() => import("./admin/pages/user_line/UserLine"));

// Core
const Forbidden = lazy(() => import("./core/pages/Forbidden"));
const NotFound = lazy(() => import("./core/pages/NotFound"));
const UnderConstructions = lazy(
  () => import("./core/pages/UnderConstructions")
);

const AppRoutes = () => {
  const bloc = useAuthBloc();

  return (
    <Fragment>
      <BlocBuilder
        bloc={bloc}
        builder={(state: AuthState) => {
          if (state.token) {
            axios.defaults.headers.common[
              "Authorization"
            ] = `Bearer ${state.token}`;

            return (
              <Routes>
                <Route path="/" element={<Admin auth={bloc} state={state} />}>
                  <Route path="" element={<TablePage />} />
                  <Route path="export" element={<ExportPage />} />
                  <Route
                    path="profile"
                    element={<Profile bloc={bloc} state={state} />}
                  >
                    <Route
                      path=""
                      element={
                        <ProfileInformation
                          data={state.user}
                          state={state}
                          bloc={bloc}
                        />
                      }
                    />
                    <Route path="password" element={<ProfilePassword />} />
                  </Route>
                  {state.user?.role === "admin" ? (
                    <Route path="lines" element={<LineContent />} />
                  ) : undefined}
                  {state.user?.role === "admin" ? (
                    <Route path="users" element={<OperatorContent />} />
                  ) : undefined}
                  <Route path="table" element={<TablePage />} />
                </Route>
                <Route path="verify/:token" element={<VerifyAccount />} />
                <Route
                  path="under-construction"
                  element={<UnderConstructions />}
                />
                <Route path="403" element={<Forbidden />} />
                <Route path="404" element={<NotFound />} />
                <Route path="*" element={<Navigate to={`/`} replace />} />
              </Routes>
            );
          }

          return (
            <Routes>
              {/**
              <Route path="forgot" element={<ForgotPassword />} />
              <Route
                path="change-password/:token"
                element={<ChangePassword />}
              />
              <Route path="verify/:token" element={<VerifyAccount />} />
              */}
              <Route path="/" element={<Navigate to={`/login`} replace />} />

              <Route path="login" element={<Login />} />
              <Route
                path="under-construction"
                element={<UnderConstructions />}
              />
              <Route path="403" element={<Forbidden />} />
              <Route path="404" element={<NotFound />} />
              <Route path="*" element={<Navigate to={`/login`} replace />} />
            </Routes>
          );
        }}
      />
    </Fragment>
  );
};

export default AppRoutes;
